document.addEventListener('DOMContentLoaded', function () {

  async function updateCart(variantId, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    });

    const cartRes = await fetch('/cart.js');
    const updatedCart = await cartRes.json();

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: updatedCart,
        data: { itemCount: updatedCart.item_count }
      }
    }));

    const item = updatedCart.items.find(i => i.variant_id == variantId);
    return item ? item.quantity : 0;
  }

  async function addToCart(variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    const cartRes = await fetch('/cart.js');
    const updatedCart = await cartRes.json();

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: updatedCart,
        data: { itemCount: updatedCart.item_count }
      }
    }));

    const item = updatedCart.items.find(i => i.variant_id == variantId);
    return item ? item.quantity : 1;
  }

  function setLoading(wrapper, loading) {
    wrapper.style.opacity = loading ? '0.5' : '1';
    wrapper.style.pointerEvents = loading ? 'none' : '';
  }

  function updateWrapper(wrapper, variantId, quantity) {
    wrapper.style.opacity = '1';
    wrapper.style.pointerEvents = '';

    if (quantity === 0) {
      wrapper.innerHTML = `
        <button class="add-to-box-btn button-secondary" data-variant-id="${variantId}">
          add to box
        </button>
      `;
    } else {
      wrapper.innerHTML = `
        <div class="add-to-box-qty button" data-variant-id="${variantId}">
          <button class="qty-btn qty-minus" data-variant-id="${variantId}">−</button>
          <span class="qty-number">${quantity}</span>
          <button class="qty-btn qty-plus" data-variant-id="${variantId}">+</button>
        </div>
      `;
    }

    delete wrapper.dataset.listenersAttached;
    attachListeners(wrapper);
  }

  function attachListeners(wrapper) {
    if (wrapper.dataset.listenersAttached) return;
    wrapper.dataset.listenersAttached = 'true';

    wrapper.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    const addBtn = wrapper.querySelector('.add-to-box-btn');
    const minusBtn = wrapper.querySelector('.qty-minus');
    const plusBtn = wrapper.querySelector('.qty-plus');

    if (addBtn) {
      addBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = this.dataset.variantId;
        setLoading(wrapper, true);
        const trueQty = await addToCart(variantId);
        updateWrapper(wrapper, variantId, trueQty);
      });
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = this.dataset.variantId;
        const currentQty = parseInt(wrapper.querySelector('.qty-number').textContent);
        const newQty = currentQty - 1;
        setLoading(wrapper, true);
        const trueQty = await updateCart(variantId, newQty);
        updateWrapper(wrapper, variantId, trueQty);
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = this.dataset.variantId;
        const currentQty = parseInt(wrapper.querySelector('.qty-number').textContent);
        const newQty = currentQty + 1;
        setLoading(wrapper, true);
        const trueQty = await updateCart(variantId, newQty);
        updateWrapper(wrapper, variantId, trueQty);
      });
    }
  }

  function initAddToBox() {
    document.querySelectorAll('.add-to-box-wrapper:not([data-listeners-attached])').forEach(wrapper => {
      attachListeners(wrapper);
    });
  }

  initAddToBox();

  const observer = new MutationObserver(function () {
    initAddToBox();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Listen for cart updates made elsewhere (e.g. cart drawer deletions)
  document.addEventListener('cart:update', async function () {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    document.querySelectorAll('.add-to-box-wrapper').forEach(wrapper => {
      const variantId = wrapper.dataset.variantId;
      const item = cart.items.find(i => i.variant_id == variantId);
      const qty = item ? item.quantity : 0;
      updateWrapper(wrapper, variantId, qty);
    });
  });

});